import { render, staticRenderFns } from "./c-dropdown@.vue?vue&type=template&id=63df9302&"
import script from "./c-dropdown@.vue?vue&type=script&lang=ts&"
export * from "./c-dropdown@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports